<template>
  <div v-if="content" class="terms">
    <div class="terms-bg">
      <picture>
        <img :src="require(`@/assets/${$store.getters.currentTheme}/images/terms-bg.png`)" alt="">
      </picture>
    </div>
    <div class="main-max-width">
      <div class="static-content">
        <!-- eslint-disable-next-line -->
        <div ref="box" :class="{ 'hidden-box': isHiddenBox, active: isOpen }" v-html="content">
        </div>
        <div v-if="!isOpen && !isHiddenButton" class="open-button" @click="isOpen = true">
          <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-arrow-down.png`)" alt=""></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { page } from '@/api/common'

export default {
  name: 'PageAbout',
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  created() {
  },
  mounted() {
    page({ type: 'about' })
      .then(response => {
        const reqData = response.data
        if (reqData && reqData.status === 200) {
          this.content = reqData.data.content
        }
        this.$nextTick(() => {
          if (this.$refs.box.clientHeight < 396) {
            this.isHiddenBox = true
            this.isHiddenButton = true
          } else {
            this.isHiddenBox = true
          }
        })
      })
  }
}
</script>

<style scoped>
</style>
